import React, { useState } from 'react';
import { Auth } from 'aws-amplify';
import { Formik, Form } from 'formik';
import VerificationConfirmation from './VerificationConfirmation';
import HGFormInput from 'components/HGForm/HGFormInput';
import HGFormSubmitBtn from 'components/HGForm/HGFormSubmitBtn';
import { LoadingSpinner } from 'components/shadcn/ui/loadingSpinner';
import HGError from 'components/HGForm/HGError';
import { Button } from 'components/shadcn/ui/button';

const VerifyUser = ({ newUser }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [resendCodeStatus, setResendCodeStatus] = useState('idle');
    const [errorMessage, setErrorMessage] = useState(null);
    const [confirmed, setConfirmed] = useState(false);

    const confirmSignUp = async (creds) => {
        setIsSubmitting(true);
        setErrorMessage(null);
        try {
            const { verificationCode } = creds;
            const confirmedUser = await Auth.confirmSignUp(
                newUser.user.username,
                verificationCode
            );
            if (confirmedUser === 'SUCCESS') {
                setConfirmed(true);
                setIsSubmitting(false);
            }
        } catch (error) {
            console.log('Error verifying code: ', error);
            setErrorMessage(error.message);
            setIsSubmitting(false);
        }
    };

    const resendSignUp = async (username) => {
        setResendCodeStatus('loading');
        setErrorMessage(null);
        try {
            await Auth.resendSignUp(username);
            setResendCodeStatus('success');
        } catch (error) {
            console.log('Error resending confirmation code: ', error);
            setErrorMessage(error.message);
        }
    };

    if (confirmed) return <VerificationConfirmation />;

    return (
        <>
            <h5 className="self-start text-xl font-medium text-foreground">
                We've sent you a verification code!
            </h5>
            <p className="mb-3 text-sm font-light text-foreground">
                Please check your email{' '}
                <strong>{newUser?.codeDeliveryDetails?.Destination}</strong>
                for a verification code. It may take a few minutes to arrive. If
                you don't see it, check your spam folder.
            </p>
            <Formik
                initialValues={{ verificationCode: '' }}
                onSubmit={confirmSignUp}
                validateOnBlur={false}
            >
                <Form className="space-between flex w-full max-w-[260px]">
                    <HGFormInput
                        name="verificationCode"
                        placeholder="Enter verification code"
                        inputClassName="rounded-l-md rounded-r-none"
                    />
                    <HGFormSubmitBtn
                        loading={isSubmitting}
                        className="max-h-[45px] w-auto rounded-l-none rounded-r-md"
                    >
                        verify
                    </HGFormSubmitBtn>
                </Form>
            </Formik>
            {errorMessage && <HGError errorMessage={errorMessage} />}
            <Button
                // trigger a snackbar or something to let user know code was resent
                className="text-foreground"
                onClick={() => resendSignUp(newUser?.user.username)}
                variant="link"
            >
                <span>
                    {resendCodeStatus === 'idle' ? (
                        'resend code'
                    ) : resendCodeStatus === 'loading' ? (
                        <LoadingSpinner className="h-5 w-5" />
                    ) : (
                        'code resent'
                    )}
                </span>
            </Button>
        </>
    );
};

export default VerifyUser;
